'use client';

import Logo from '@alltrails/denali/components/Logo';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import useUser from '@alltrails/context/hooks/useUser';
import logWebHeaderAllTrailsLogoTapped from '@alltrails/amplitude/events/logWebHeaderAllTrailsLogoTapped';
import Link from '@alltrails/denali/components/Link';
import { ComponentProps, useMemo } from 'react';
import styles from './styles/styles.module.scss';
import { HeaderBackground } from './types';

type LogoLinkProps = {
  background?: HeaderBackground;
};

const LogoLink = ({ background }: LogoLinkProps) => {
  const isMobile = useIsMobileSizedScreen();
  const user = useUser();

  const logoProps = useMemo<Pick<ComponentProps<typeof Logo>, 'color' | 'variant'>>(() => {
    if (user || isMobile) {
      return {
        color: background === 'transparent-inverted' ? 'monochrome-light' : 'monochrome-dark',
        variant: 'symbol'
      };
    }
    return {
      color: background === 'transparent-inverted' ? 'colored-light' : 'colored-dark',
      variant: 'logomark'
    };
  }, [background, isMobile, user]);

  return (
    <div className={styles.focusContainer}>
      <Link
        className={styles.logoLink}
        testId="header-logo"
        href="/"
        onClick={() => {
          logWebHeaderAllTrailsLogoTapped();
        }}
      >
        <Logo {...logoProps} size="sm" />
      </Link>
    </div>
  );
};
export default LogoLink;
